import React from 'react';
import { FormWithPrivacyHandler } from 'components/molecules/custom-form';
import {
  useDiscussionsDispatch,
  editCommmentOnStore,
} from '../discussions-store';

export const EditComment = ({
  initialHtml,
  placeholder,
  projectId,
  docId,
  comment,
  onEditFormClose,
}) => {
  const dispatch = useDiscussionsDispatch();
  const handleEdit = (content) => {
    if (content.length > 1) {
      editCommmentOnStore(dispatch, {
        projectId,
        docId,
        comment,
        content,
      });
      onEditFormClose();
    }
  };

  return (
    <FormWithPrivacyHandler
      initialFormVisibility
      submitFormLabel="save"
      onSubmit={handleEdit}
      isPrivate={comment.private}
      onClose={onEditFormClose}
      initialData={initialHtml}
      placeholder={placeholder}
      hidePrivateToggler
      projectId={projectId}
    />
  );
};
